import { useEffect } from "react";
import { Search, Users, Rocket } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";
import PageHero from "@/components/PageHero";
import { TeamProposalForm } from "@/components/LeadForms";
import { Reveal } from "@/components/Reveal";

const NEXT_STEPS = [
  {
    icon: Search,
    title: "We review your requirements",
    copy: "We look at the role, skills, hours and outcomes you're looking for.",
  },
  {
    icon: Users,
    title: "We propose the right structure",
    copy: "You get a tailored proposal covering people, pricing and the delivery model.",
  },
  {
    icon: Rocket,
    title: "You meet candidates and launch",
    copy: "Meet shortlisted professionals, choose your team and we handle onboarding.",
  },
];

export default function GetYourTeam() {
  useEffect(() => {
window.scrollTo({
top: 0,
left: 0,
behavior: "auto",
});
}, []);
  useSEO(
    "Build Your Team | Request a Team Proposal | Synergy Outsourcing",
    "Tell us what you need and we'll help you build a dedicated managed team. No obligation: get a tailored team proposal from Synergy Outsourcing."
  );
  return (
    <>
      <PageHero
        eyebrow="Build your team"
        lines={["Tell us what you need.", "We'll help build", "the team."]}
        copy="No obligation. We'll review your requirements and come back with the most suitable options."
      />
      <section className="py-14 sm:py-16" data-testid="get-your-team-section">
        <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
          <Reveal className="lg:col-span-7">
            <div className="rounded-2xl border border-white/10 bg-ink-2 p-8 sm:p-10">
              <TeamProposalForm />
            </div>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5">
            <div className="lg:sticky lg:top-24">
              <h2 className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-brand">
                What happens next
              </h2>
              <div className="mt-6 space-y-5">
                {NEXT_STEPS.map((s, i) => (
                  <div key={s.title} className="flex gap-4 rounded-2xl border border-white/10 bg-ink-2 p-6" data-testid={`next-step-${i}`}>
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-soft text-brand">
                      <s.icon className="h-5 w-5" aria-hidden="true" />
                    </span>
                    <div>
                      <h3 className="font-display text-base font-semibold text-white">{s.title}</h3>
                      <p className="mt-1 text-sm leading-relaxed text-mist">{s.copy}</p>
                    </div>
                  </div>
                ))}
              </div>
              <p className="mt-6 rounded-2xl border border-white/10 bg-ink-2 p-6 text-sm leading-relaxed text-mist">
                Prefer to talk it through first? Email us at{" "}
                <a href="mailto:info@synergyos.com.au" className="text-brand-bright transition-colors hover:text-white" data-testid="gyt-email-link">
                  info@synergyos.com.au
                </a>{" "}
                and we'll set up a conversation.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
